import { useNavigate, useParams } from "react-router-dom";
import WriteEssay from "../Writing";

export function WritePage() {
  const { themeSlug } = useParams();
  const navigate = useNavigate();

  const handleFinish = () => {
    navigate(`/redacoes/minhas_redacoes`);
  }

  return (
    <WriteEssay key={themeSlug} origin="essay" slug={themeSlug} finish={() => handleFinish()} />
  )
}